import { Space, Typography } from "antd";

import { FC } from "react";
import { useTheme } from "../../../../Styles/ThemeHook";
import { BedIcon2 } from "shared-components/Components/CustomIcons/BedIcon2/web";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";

interface BedroomsTagProps {
	bedrooms: number;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const BedroomsTag: FC<BedroomsTagProps> = ({
	bedrooms,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	const { theme } = useTheme();

	return (
		<Space size={theme.spacing.smSpacing}>
			{isEspecial ? (
				<>
					{icon && <BedIcon2 className="icon" />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Dorm.
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `+${bedrooms > 0 ? bedrooms : "Mono"}` : bedrooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <BedIcon style={{ color: theme.colors.textSecondaryColor }} />}
					<Typography.Text ellipsis>
						{`${prefix ? "+" : ""}${bedrooms} Dorm.`}
						
					</Typography.Text>
				</>
			)}
		</Space>
	);
};
